import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axiosInstance from '../api/axiosInstance';

const baseUrl = process.env.REACT_APP_API_URL;

interface PrecheckPos {
  id: number;
  company: string;
  taxId: string;
  creditorId: string;
  industry: string;
  address: string;
  locations: string;
  website: string;
  director: string;
  contactPerson: string;
  email: string;
  telephone: string;
  mobile: string;
  currentProvider: string;
  turnover: string;
  receiptSize: string;
  bankStatementReference: string;
  terminals: string;
  checkoutConnection: string;
  cashCut: string;
  tip: string;
  cards: string[];
  additionalServices: string[];
  createdAt: string;
}

const usePrecheckPOS = () => {
  const { id } = useParams<{ id: string }>();
  const [precheckPos, setPrecheckPos] = useState<PrecheckPos | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPrecheckPos = async () => {
      try {
        const response = await axiosInstance.get(`${baseUrl}/admin/precheck-pos/${id}`);
        setPrecheckPos(response.data);
      } catch (err) {
        setError('Failed to fetch Precheck POS');
        console.error('Error fetching Precheck POS:', err);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchPrecheckPos();
    }
  }, [id]);

  return { precheckPos, loading, error };
};

export default usePrecheckPOS;
